export default __webpack_public_path__ + "static/daniel-ioi-7256fc901cb8b2413b13535909579ce3.jpg";